export interface MaasAvailableYearsResponse {
	status: boolean;
	data?: number[];
	message?: string;
	serials?: string[];
}

export interface MaasAvailableYears {
	years: number[];
	unusableSerials: string[];
}

export const MaasAvailableYearsMessage = {
	EndpointNotUsableForVehicles: 'endpoint_not_usable_for_vehicles',
} as const;
